import { SharePointParentFolder } from 'shared'
import DetailsBody, { DetailsBodyValues } from './components/DetailsBody'
import AdditionalInfoBody from './components/AdditionalInfoBody'
import { useGlobalState } from 'context/GlobalStateContext'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { useCreateCaSubmittalMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import AdvancedCreateModal from 'components/CIMSModal/AdvancedCreateModal'
import { ExternalLinkEditorValues } from 'components/ExternalLinkEditor/types'
import { AdditionalInfoBodyValues } from './components/AdditionalInfoBody/types'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { errorHandler } from '../../../../../../../../../../../../../hooks/errorHandler'

const CreateModal: React.FC = () => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const {
    refetch,
    createModal: { visible, toggle },
    quickLinks,
    metaFetching,
  } = useSubmittalTrackerContext()
  const { fromLabeledValues } = usePayItemSelectContext()
  const [create] = useCreateCaSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createConstructionAdminSubmittal: {
        submittal: { sharePointFolderName },
      },
    }) => simpleCreateNotification(sharePointFolderName),
  })
  const { toMutateCustomFieldsInput } = useProjectCustomFieldsContext()
  return (
    <AdvancedCreateModal
      visible={visible}
      onClose={() => toggle(null)}
      details={<DetailsBody />}
      additionalInfo={<AdditionalInfoBody />}
      attachments={{
        sharePoint: {
          parent: SharePointParentFolder.ConstructionAdminSubmittals,
          folder: ({ packageNumber, packageName }) =>
            `${packageNumber}-${packageName}`,
        },
        externalLinks: { quickLinks, loading: metaFetching },
      }}
      ok={{
        title: 'Ok',
        fn: async (store) => {
          if (!projectId) return errorHandler('Project id must be defined')
          const values = store as DetailsBodyValues &
            AdditionalInfoBodyValues &
            ExternalLinkEditorValues
          const {
            packageName,
            packageNumber,
            typeId,
            subtypeId,
            quantity,
            units,
            requestedReviewDate,
            payItemIds,
            externalLinks,
            customFields,
          } = values
          await create({
            variables: {
              input: {
                projectId,
                packageName,
                packageNumber,
                typeId: typeId.value?.toString(),
                subtypeId: subtypeId?.value?.toString(),
                quantity,
                units,
                requestedReviewDate: requestedReviewDate.toISOString(),
                payItemIds: fromLabeledValues(payItemIds),
                externalLinks,
                customFields: toMutateCustomFieldsInput(customFields),
              },
            },
          })
          refetch()
        },
      }}
    />
  )
}

export default CreateModal
